const policyH1 = document.querySelector(".shopify-policy__title h1");
if (policyH1) {
  const policyHandle = location.pathname.split("/").at(-1);
  const titleEn = policyHandle.replace("-", " ");
  policyH1.innerHTML = `<span>${policyH1.textContent}</span>`;
  policyH1.dataset.en = titleEn;
  policyH1.classList.add("rba-title");
}
